"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setLanguage = setLanguage;
exports.getLanguage = getLanguage;
var cookies_1 = require("utils/cookies");
var constants_1 = require("utils/constants");
var moment = require("moment");
var currentLang = (0, cookies_1.getCookie)('language') || constants_1.DEFAULT_LANGUAGE;
function setLanguage(language) {
    currentLang = language;
    moment.updateLocale(language, {
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'DD.MMMM.YYYY',
            LLL: 'DD.MMMM.YYYY HH:mm',
            LLLL: 'dddd.DD.MMMM.YYYY HH:mm'
        }
    });
    moment.locale(language);
    (0, cookies_1.setCookie)('language', language, constants_1.LANGUAGE_EXPIRES);
}
function getLanguage() {
    return currentLang;
}
